module.exports = __webpack_public_path__ + "static/media/plus-circle-solid.944e4bf1.svg";